import React, { useState } from "react"
import contact1 from "./contact1.png"
import rasm2 from "./rasm2.jpg"
import "./Contact.css"
import TelegramIcon from '@mui/icons-material/Telegram';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import Contact2 from "./Contact2"

const Contact = () => {
  const [data, setData] = useState({
    fullname: "",
    phone: "",
    email: "",
    subject: "",
    message: "",})

  const InputEvent = (event) => {
    const { name, value } = event.target

    setData((preVal) => {
      return {
        ...preVal,
        [name]: value,
      }
    })
  }

  const formSubmit = (event) => {
    event.preventDefault()
    alert(
      `My name is ${data.fullname}. 
	My phone number is ${data.phone}. 
	My email address is ${data.email}. 
	My Subject on  ${data.subject}. 
	Here is my message I want to say : ${data.message}. 
	`
    )
  }
  return (
    <>
      <section className='Contact' id='contact'>
        <div className='container top'>
          <div className='heading text-center'>
            <h1>Contact With Me</h1>
          </div>

          <div className='content d_flex'>
            <div className='left'>
              <div className='box'>
                <div className='img'>
                  <img className="rasm" src={rasm2} alt='' />
                </div>
                <div className='details'>
                  <h1>Sherzod Tashpolatov</h1>
                  <p>Web Developer</p>
                  <p>I am available for freelance work. Contact me via gmail or phone number !</p> <br />
                  <p>Phone: +998(33)067-06-06</p>
                  <p>Phone: +998(91)001-20-91</p>
                  <p>Email: toshpolatovsherzod1@gmail.com</p> <br />
                  <span>FIND WITH ME</span>
                  <div className='button f_flex'>
                    <button className='btn_shadow'>
                      <i className='fab fa-facebook-f'></i>
                      <a href="https://www.facebook.com/profile.php?id=100054789188742"><FacebookOutlinedIcon /></a>
                    </button>
                    <button className='btn_shadow'>
                      <i className='fab fa-instagram'></i>
                      <a href="https://www.instagram.com/01werka/"><InstagramIcon /> </a>
                    </button>
                    <button className='btn_shadow'>
                      <i className='fab fa-telegram'></i>
                      <a href="https://t.me/werka01"> <TelegramIcon /> </a>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="right">
              <Contact2/>
            </div>

            {/* <div className='right box_shodow'>
              <form onSubmit={formSubmit}>
                <div className='f_flex'>
                  <div className='input row'>
                    <span>YOUR NAME</span>
                    <input type='text' name='fullname' value={data.fullname} onChange={InputEvent} />
                  </div>
                  <div className='input row'>
                    <span>PHONE NUMBER </span>
                    <input type='number' name='phone' value={data.phone} onChange={InputEvent} />
                  </div>
                </div>
                <div className='input'>
                  <span>EMAIL </span>
                  <input type='email' name='email' value={data.email} onChange={InputEvent} />
                </div>
                <div className='input'>
                  <span>SUBJECT </span>
                  <input type='text' name='subject' value={data.subject} onChange={InputEvent} />
                </div>
                <div className='input'>
                  <span>YOUR MESSAGE </span>
                  <textarea cols='30' rows='10' name='message' value={data.message} onChange={InputEvent}></textarea>
                </div>
                <button className='btn_shadow'>
                  SEND MESSAGE <i className='fa fa-long-arrow-right'></i>
                </button>
              </form>
            </div> */}
          </div>
        </div>
      </section>
    </>
  )
}

export default Contact
